import { IconButton, Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Divider from '@material-ui/core/Divider';
import FormatListBulleted from '@material-ui/icons/FormatListBulleted';
import Grid from '@material-ui/core/Grid';
import React, { Component } from 'react';
import Typography from 'fuse-ui/components/Typography';
import cx from 'classnames';

import PropTypes from 'prop-types';

import { opacity } from '../../common/theme/colors';
import DownloadMenuContainer from '../containers/download-menu-container';
import Legend from '../../common/components/charts/legend';
import ReportHeader from './report-header';

const styles = theme => ( {
    cardContent: {
        marginBottom: theme.spacing.unit * 2,
        paddingBottom: 0,
        paddingTop: 0,
    },
    cardRoot: {
        '@media print': {
            border: 'none'
        },
        marginTop: theme.spacing.unit * 2,
    },
    hideTable: {
        'float': 'right',
        margin: `${theme.spacing.unit}px 0 0 0`,
    },
    hideTableLabel: {
        height: 24,
        width: 24,
    },
    leftContent: {
        paddingTop: theme.spacing.unit * 2,
        position: 'relative'
    },
    opacity08: {
        '&:focus': {
            background: opacity.black08
        },
        background: opacity.black08,
    },
    rightContent: {
        paddingBottom: '0 !important'
    },
    sectionHeading: {
        marginBottom: theme.spacing.unit * 2,
        marginTop: theme.spacing.unit * 2,
        textDecoration: 'underline'
    },
} );

export class ReportingCard extends Component{
    state = {
        showTable: false
    };

    handleClick = event => {
        this.setState( { showTable: !this.state.showTable } );
    };
    render( ){
        const { classes, header, type, content, order, allowDownload, dataIsLoading } = this.props;
        const { showTable } = this.state;
        const chartName = type + 'Chart';
        return (
            <Card className={classes.cardRoot}>
                <ReportHeader header={header} />
                { allowDownload && <DownloadMenuContainer tableNameToExport={ type } chartName={ chartName } /> }
                {
                    content.table &&
                    ( <div className="no-print">
                        <Tooltip title="Show/hide table" placement="top">
                            <IconButton className={cx( classes.hideTable, { [classes.opacity08]: showTable } )}
                                classes={{ label: classes.hideTableLabel }}
                                aria-haspopup="true"
                                data-automation-id="hide-table-icon"
                                onClick={this.handleClick}
                            >
                                <FormatListBulleted />
                            </IconButton>
                        </Tooltip>
                    </div> )
                }
                <CardHeader
                    title={(
                        <span className="no-print">
                            <Typography variant="h6">
                                {content.title}
                            </Typography>
                            {
                                content.subtitle &&
                                ( <Typography variant="subtitle1" color="secondary">
                                    {content.subtitle}
                                </Typography> )
                            }
                        </span>
                    )}
                />
                <CardContent className={classes.cardContent}>
                    <Grid container>
                        <Grid item xs={12} sm={3} className={classes.leftContent}>
                            <Typography variant="subtitle1">
                                <span className="only-print-inline">{order}.0 &nbsp;</span>
                                {content.textheader}
                            </Typography>
                            <Typography variant="subtitle1" className="only-print" classes={{ root: classes.sectionHeading }}>
                                {order}.1 Analysis
                            </Typography>
                            {content.leftContent}
                            {content.footer && <Typography variant="caption">{content.footer}</Typography>}
                            <Typography variant="subtitle1" className="only-print" classes={{ root: classes.sectionHeading }}>
                                {order}.2 Visual Summary
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={9}>
                            <CardContent id={ chartName } className={classes.rightContent}>
                                {content.rightContent}
                            </CardContent>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            {!dataIsLoading && content.legend && ( <Legend
                                legendItems={[{
                                    iconType: 'line',
                                    message: content.legend.dotLabel,
                                }, {
                                    iconType: 'dot',
                                    message: content.legend.streamLabel,
                                }]}
                            /> )}
                        </Grid>
                    </Grid>
                </CardContent>
                {
                    content.table && !dataIsLoading &&
                        ( <div className="no-print" style={{ display: showTable ? 'block' : 'none' }} data-automation-id="table-container">
                            <Divider />
                            {content.table}
                        </div> )
                }
            </Card>
        );
    }
};

ReportingCard.propTypes = {
    allowDownload: PropTypes.bool,
    classes: PropTypes.object,
    content: PropTypes.shape( {
        leftContent: PropTypes.element.isRequired,
        rightContent: PropTypes.element.isRequired,
        subtitle: PropTypes.string,
        table: PropTypes.oneOfType( [
            PropTypes.element,
            PropTypes.bool
        ] ),
        textheader: PropTypes.string,
        title: PropTypes.string.isRequired,
    } ),
    dataIsLoading: PropTypes.bool.isRequired,
    header: PropTypes.shape( {
        domain: PropTypes.string,
        domainType: PropTypes.string,
        endDate: PropTypes.string.isRequired,
        interval: PropTypes.string.isRequired,
        startDate: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
    } ),
    order: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
};

export default withStyles( styles )( ReportingCard );
